
export enum ModalButtons {
    None = 0,
    Ok = 1,
    Cancel = 2,
    Yes = 4,
    No = 8,
    Save = 16,
    Import = 32,
    Add = 64
}

// tslint:disable:no-bitwise
export class ModalButtonSet {
    static SaveImportCancel:  number = ModalButtons.Save | ModalButtons.Import | ModalButtons.Cancel;
    static SaveCancel:  number = ModalButtons.Save | ModalButtons.Cancel;
    static AddCancel:  number = ModalButtons.Add | ModalButtons.Cancel;
    static OkCancel:  number = ModalButtons.Ok | ModalButtons.Cancel;
    static YesNo: number = ModalButtons.Yes | ModalButtons.No;
    static Cancel: number = ModalButtons.Cancel;
    static Ok: number = ModalButtons.Ok;
    static None: number = ModalButtons.None;
}
